/**
 * Car contact form
 */
class CarContactForm {
  #form;
  #tradeCarCheckbox;
  #tradeCarFields;

  /**
   * @constructor
   * @param {HTMLElement} element HTMLElement object to bind functionality
   */
  constructor(element) {
    this.#form = element;
    this.#tradeCarCheckbox = this.#form.querySelector('input#trade');
    this.#tradeCarFields = this.#form.querySelector('#tradeCarFields');

    this._bind();
    this._toggleTradeCarFields();
  }

  /**
   * Bind events
   */
  _bind() {
    this.#tradeCarCheckbox.addEventListener('change', this._toggleTradeCarFields.bind(this));
  }

  /**
   * Hide and show trade car fields
   */
  _toggleTradeCarFields() {
    if (this.#tradeCarCheckbox.checked) {
      const contentHeight = this.#tradeCarFields.scrollHeight;
      this.#tradeCarFields.style.maxHeight = `${contentHeight}px`;
    } else {
      this.#tradeCarFields.style.maxHeight = 0;
    }
  }

  /**
   * Initialize the car contact form on the page.
   * @static
   */
  static init() {
    document.querySelectorAll('.car-contact-form').forEach(element => {
      new CarContactForm(element);
    });
  }
}

export default CarContactForm;
